import React from "react";
import { Button, styled } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

/* ✅ Styled Button */
const DownloadButton = styled(Button)(({ theme }) => ({
    backgroundColor: "goldenrod",
    color: "#100720",
    fontWeight: "bold",
    padding: "10px 20px",
    borderRadius: "8px",
    marginTop: "20px",
    "&:hover": {
        backgroundColor: "#e0b200",
    },
}));

export default function DownloadPDFButton() {
    const handleDownload = () => {
        window.print(); // ✅ Browser opens PDF dialog
    };

    return (
        <DownloadButton
            variant="contained"
            startIcon={<PictureAsPdfIcon />}
            onClick={handleDownload}
        >
            Download as PDF
        </DownloadButton>
    );
}
